module.exports = __webpack_public_path__ + "img/rubber.57627c6b.svg";